import React from 'react';

import Tippy from '@tippyjs/react';
import cs from 'classnames';

import { groupAndSort, snakeToTitleCase } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';

import { getFirstName, getLastName } from '../lib/getName';

const AllAvatars = ({
  items,
  size,
  fontSize,
  itemSize,
  itemsToShow = 4,
  isCompact,
  placement,
  itemsGroupBy,
  itemsGroupLabelClassName
}) => {
  const remainingCount = items.length - itemsToShow;

  if (remainingCount <= 0) return null;

  const groupedItems = groupAndSort(items, itemsGroupBy);

  return (
    <Tippy
      className="custom-tooltip w-max max-w-[300px] py-2"
      animation="fade"
      interactive={true}
      arrow={false}
      placement={placement}
      content={
        <div className="mr-1 flex max-h-[400px] flex-col gap-1 overflow-y-auto">
          {groupedItems.map(([groupName, groupItems], groupIndex) => (
            <div key={groupIndex}>
              {itemsGroupBy && (
                <span
                  className={cs(
                    'px-4 py-1 text-xs font-500 leading-[14px] text-primary-500',
                    itemsGroupLabelClassName
                  )}>
                  {snakeToTitleCase(groupName)}
                </span>
              )}
              {groupItems.map((item, index) => (
                <div key={index} className="flex select-none items-center gap-2 py-1 pl-4 pr-3">
                  <Avatar
                    size="large"
                    fontSize="text-xs"
                    firstName={getFirstName(item)}
                    lastName={getLastName(item)}
                    image={item.image}
                    id={item.id}
                    isSquare={false}
                  />
                  <div className="flex flex-col overflow-hidden">
                    <span
                      className="line-clamp-1 text-sm font-500 leading-[18px] text-neutral-800"
                      title={`${getFirstName(item)} ${getLastName(item)}`}>
                      {getFirstName(item)} {getLastName(item)}
                    </span>
                    <p
                      className="line-clamp-2 text-xs font-400 leading-[14px] text-neutral-700"
                      title={item.description}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      }>
      <div
        className={cs(
          'flex items-center justify-center rounded-full',
          !isCompact && 'bg-neutral-50 outline-none outline-offset-0 outline-white',
          size === 'small' || size === 'medium' ? 'ml-1' : 'ml-[6px]'
        )}
        style={{
          width: itemSize,
          height: itemSize,
          marginLeft: !isCompact && -itemSize / 4, // add margin based on the size of the avatar
          zIndex: itemsToShow + 1
        }}>
        <span className={cs('flex items-center font-600 text-neutral-700', fontSize)}>
          <span className="mb-[2px] leading-3 ">+</span>
          <span>{remainingCount}</span>
        </span>
      </div>
    </Tippy>
  );
};

export default AllAvatars;
